<template>
  <div id="youtube" class="content-help-wrapper">
    <!-- <object width="100%" controls height="500px"> -->
    <!-- <param name='FlashVars' value="ver="  /> -->
    <!-- <param name='movie' :value="path + '?module=' + $store.getters.getPasscode "  />
            <param name='quality' value='high' />
            <param name='bgcolor' value='#ffffff' />
            <param name='wmode' value='opaque' /> -->
    <embed height="400px" class="player" v-bind:src="path" width="100%" />
    <!-- </object> -->
  </div>
</template>

<script>
export default {
  name: 'youtube-player',
  props: ['path'],
  loaded: true,
  data () {
    return {

    }
  },
  watch: {
    path: function (newValue, oldValue) {
      this.init(newValue, oldValue)
    }
  },
  methods: {
    init (newValue, oldValue) {
      return new Promise(resolve => {
        let innerHTMLObj = '<object  width="100%"  > <embed class="player" height="400px" src="' + newValue + '" width="100%" ></embed> </object>'
        this.youtube = document.getElementById('youtube')
        if (typeof this.youtube === undefined || this.youtube === null || this.youtube === '') {
          // resolve(true)
        } else {
          this.youtube.innerHTML = ''
          // console.log('here' + this.$store.getters.getPasscode)
          this.youtube.innerHTML = innerHTMLObj
        }
        resolve(true)
      })
    }
  }
}
</script>
<style lang="scss">
embed {
  height: 300px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/contentViewer/contentHelper/youtube-player.vue?e6c26dc4